<script setup lang="ts">
import { getOpenGraph, getTwitter } from '~/helpers/useMetaData'

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    en: '/search',
    fr: '/recherche',
  },
})
definePageMeta({
  footer: 'compact',
  gtmAdditionalEventData: { page_type: 'search' },
})

const { t, locale } = useI18n()
const route = useRoute()
const { userIsAdmin, userIsPartner } = useAuth()
const searchMetaDescription = t('search.meta_description')
const searchMetaTitle = t('search.title')
const stateHousePreviousPage = useState('house-previous-page')

const meta = ref([
  {
    hid: 'description',
    name: 'description',
    content: searchMetaDescription,
  },
  ...getOpenGraph(searchMetaTitle, searchMetaDescription),
  ...getTwitter(searchMetaTitle, searchMetaDescription),
])

if (route.query.destinationId) {
  meta.value.push({
    hid: 'robots',
    name: 'robots',
    content: 'noindex',
  })
}

onBeforeRouteLeave((_, from) => {
  if (typeof from?.name === 'string') {
    const previousPage = {
      name: from.name.slice(0, -5),
      params: from.params,
      query: from.query,
    }

    stateHousePreviousPage.value = previousPage
  }
})

useHead({
  title: searchMetaTitle,
  meta,
})

await useAsyncData('search', async () => {
  await useSearch({
    loadDesti: true,
    loadFacetSeo: false,
    locale,
  })

  return true
})
</script>

<template>
  <div>
    <SearchAdminLayout v-if="userIsAdmin" />
    <SearchPartnerLayout v-else-if="userIsPartner" />
    <SearchClientLayout v-else />
  </div>
</template>
